function headerElementClickTracking(target, category) {
    dataLayer.push({
        event: "click",
        params: {
            name: "navigation",
            location: "menu",
            target: target,
            page_category: category
        }, 
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var nextButton = document.querySelector('.Form__NavigationBar__Action.btnNext');
    var currentStepElement = document.querySelector('.Form__NavigationBar__ProgressBar__CurrentStep');
    var formTitleElement = document.querySelector('li[data-current-page-breadcrumb]');

    if (nextButton && currentStepElement && formTitleElement) {
        nextButton.addEventListener('click', function () {
            var currentStepNumber = currentStepElement.textContent;
            var formTitle = formTitleElement.textContent;
            dataLayer.push({
                event: "support_form",
                validation_form: {
                    form_name: formTitle,
                    step_index: currentStepNumber
                },
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var submitButton = document.querySelector('.Form__Element.FormSubmitButton');
    var currentStepElement = document.querySelector('.Form__NavigationBar__ProgressBar__CurrentStep');
    var formTitleElement = document.querySelector('li[data-current-page-breadcrumb]');

    if (submitButton && currentStepElement && formTitleElement) {
        submitButton.addEventListener('click', function () {
            var currentStepNumber = currentStepElement.textContent;
            var formTitle = formTitleElement.textContent;
            dataLayer.push({
                event: "support_form",
                validation_form: {
                    form_name: formTitle,
                    step_index: currentStepNumber,
                    form_submitted: "TRUE"
                },
            });
        });
    }
});